import { smartCatalogInstance } from './instances'

import smartCatalogModule from './smart-catalog'

const smartCatalog = smartCatalogModule(smartCatalogInstance)

export {
  smartCatalog
}
